import { render, staticRenderFns } from "./BEDateComp.vue?vue&type=template&id=7ae74d67&scoped=true&"
import script from "./BEDateComp.vue?vue&type=script&lang=js&"
export * from "./BEDateComp.vue?vue&type=script&lang=js&"
import style0 from "./BEDateComp.vue?vue&type=style&index=0&id=7ae74d67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae74d67",
  null
  
)

export default component.exports